// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd2-cls1_GVg","cls2":"PodcastLibraryAd2-cls2_3b1 PodcastLibraryAd2-cls1_GVg"};